// import { FaPlay, FaArrowRight } from "react-icons/fa";

// const getYoutubeVideoId = (url) => {
//   try {
//     const parsed = new URL(url);

//     if (parsed.hostname.includes("youtu.be")) {
//       return parsed.pathname.slice(1);
//     }

//     if (parsed.hostname.includes("youtube.com")) {
//       return parsed.searchParams.get("v");
//     }

//     return null;
//   } catch {
//     return null;
//   }
// };

// const getYoutubeThumbnail = (url) => {
//   const videoId = getYoutubeVideoId(url);

//   if (!videoId) {
//     return "/images/video-placeholder.webp";
//   }

//   return `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`;
// };
// export default function TutorialVideos({ videos }) {
//   const filteredVideos = videos?.filter((video) =>
//     video.title.includes("Part"),
//   );
//   return (
//     <section className="bg-[#FFFFFF] py-20 px-6">
//       <div className="max-w-6xl mx-auto">
//         {/* Heading */}
//         <div className="text-center mb-12">
//           <h2 className="text-[#10324F] text-2xl md:text-3xl font-bold">
//             Explore Waggex Feature Tutorials
//           </h2>

//           <p className="mt-4 text-[#10324F] max-w-3xl mx-auto text-base md:text-lg">
//             Embed your YouTube videos inside these cards or link each card to
//             the relevant tutorial video.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-8">
//           {filteredVideos?.map((video, index) => (
//             <div
//               key={video._id}
//               className="bg-white rounded-3xl p-4 border border-gray-100"
//               style={{
//                 backdropFilter: "blur(30px)",
//                 WebkitBackdropFilter: "blur(30px)",
//                 boxShadow: `
//       inset -15px -15px 20px 0px rgba(209, 223, 234, 0.4),
//       -20px -20px 30px 0px rgba(209, 223, 234, 0.3)
//     `,
//               }}
//             >
//               {/* Thumbnail */}
//               <div className="relative overflow-hidden rounded-2xl">
//                 <img
//                   src={getYoutubeThumbnail(video.videoLink)}
//                   alt={video.title}
//                   width="320"
//                   height="180"
//                   className="sm:w-full sm:h-46 object-cover"
//                   loading="lazy"
//                   referrerPolicy="no-referrer"
//                   onError={(e) => {
//                     e.target.src =
//                       "https://i.ytimg.com/vi/default/sddefault.jpg";
//                   }}
//                 />

//                 {/* Play Button */}
//                 <a
//                   href={video.videoLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   aria-label={`Watch ${video.title} on YouTube`}
//                   title={`Watch ${video.title} on YouTube`}
//                   className="absolute bottom-4 right-4 w-14 h-14 rounded-full bg-[#10324F]/40 border  border-white backdrop-blur-3xl flex items-center justify-center hover:scale-105 transition"
//                 >
//                   <FaPlay className="text-white ml-1" />
//                 </a>
//               </div>

//               {/* Content */}
//               <div className="pt-5">
//                 <h2 className="font-bold text-[#10324F] text-sm line-clamp-2 mb-2  min-h-8">
//                   {video.title}
//                 </h2>

//                 <p className="text-[#10324F] text-xs leading-tight min-h-12 mb-2 hidden sm:block">
//                   {video.description}
//                 </p>

//                 <a
//                   href={video.videoLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center gap-2 text-[#10324F] font-normal underline  text-sm hover:gap-3 transition-all"
//                 >
//                   Watch on Youtube
//                   <FaArrowRight size={12} />
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

import { FaPlay, FaArrowRight } from "react-icons/fa";

const getYoutubeVideoId = (url) => {
  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes("youtu.be")) {
      return parsed.pathname.slice(1);
    }

    if (parsed.hostname.includes("youtube.com")) {
      return parsed.searchParams.get("v");
    }

    return null;
  } catch {
    return null;
  }
};

const getYoutubeThumbnail = (url) => {
  const videoId = getYoutubeVideoId(url);

  if (!videoId) {
    return "/images/video-placeholder.webp";
  }

  return `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`;
};

const VideoSkeleton = () => {
  return (
    <div className="animate-pulse bg-white rounded-3xl p-4 border border-gray-100">
      {/* Thumbnail */}
      <div className="bg-[#8aa0ba] rounded-2xl aspect-video w-full"></div>

      {/* Content */}
      <div className="pt-5 space-y-3">
        <div className="h-4 bg-[#8aa0ba] rounded w-3/4"></div>

        <div className="hidden sm:block space-y-2">
          <div className="h-3 bg-[#8aa0ba] rounded w-full"></div>
          <div className="h-3 bg-[#8aa0ba] rounded w-2/3"></div>
        </div>

        <div className="h-4 bg-[#8aa0ba] rounded w-28"></div>
      </div>
    </div>
  );
};

export default function TutorialVideos({ videos = [], isVideoloading }) {
  const filteredVideos = videos?.filter((video) =>
    video.title?.includes("Part"),
  );

  return (
    <section className="bg-[#FFFFFF] py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-[#10324F] text-2xl md:text-3xl font-bold">
            Explore Waggex Feature Tutorials
          </h2>

          <p className="mt-4 text-[#10324F] max-w-3xl mx-auto text-base md:text-lg">
            Embed your YouTube videos inside these cards or link each card to
            the relevant tutorial video.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-8">
          {isVideoloading
            ? Array.from({ length: 4 }).map((_, index) => (
                <VideoSkeleton key={index} />
              ))
            : filteredVideos?.map((video) => (
                <div
                  key={video._id}
                  className="bg-white rounded-3xl p-4 border border-gray-100"
                  style={{
                    backdropFilter: "blur(30px)",
                    WebkitBackdropFilter: "blur(30px)",
                    boxShadow: `
                    inset -15px -15px 20px 0px rgba(209, 223, 234, 0.4),
                    -20px -20px 30px 0px rgba(209, 223, 234, 0.3)
                  `,
                  }}
                >
                  {/* Thumbnail */}
                  <div className="relative overflow-hidden rounded-2xl">
                    <img
                      src={getYoutubeThumbnail(video.videoLink)}
                      alt={video.title}
                      width="320"
                      height="180"
                      className="w-full aspect-video object-cover"
                      loading="lazy"
                      referrerPolicy="no-referrer"
                      onError={(e) => {
                        e.target.src = "/images/video-placeholder.webp";
                      }}
                    />

                    {/* Play Button */}
                    <a
                      href={video.videoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Watch ${video.title} on YouTube`}
                      title={`Watch ${video.title} on YouTube`}
                      className="absolute bottom-4 right-4 w-14 h-14 rounded-full bg-[#10324F]/40 border border-white backdrop-blur-3xl flex items-center justify-center hover:scale-105 transition"
                    >
                      <FaPlay className="text-white ml-1" />
                    </a>
                  </div>

                  {/* Content */}
                  <div className="pt-5">
                    <h2 className="font-bold text-[#10324F] text-sm line-clamp-2 mb-2 min-h-8">
                      {video.title}
                    </h2>

                    <p className="text-[#10324F] text-xs leading-tight min-h-12 mb-2 hidden sm:block">
                      {video.description}
                    </p>

                    <a
                      href={video.videoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-[#10324F] font-normal underline text-sm hover:gap-3 transition-all"
                    >
                      Watch on Youtube
                      <FaArrowRight size={12} />
                    </a>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}
